import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _DarkTheme5_;
import { createTheme, markThemeVersion } from "../../../lib/theming/ThemeHelpers";
import { BasicThemeClassForExtension } from "../BasicTheme";
import { DarkTheme5_0 } from "../DarkTheme5_0";
export var DarkTheme5_1 = createTheme({
  themeClass: (_DarkTheme5_ = /*#__PURE__*/function (_BasicThemeClassForEx) {
    function DarkTheme5_1() {
      return _BasicThemeClassForEx.apply(this, arguments) || this;
    }
    _inheritsLoose(DarkTheme5_1, _BasicThemeClassForEx);
    return _createClass(DarkTheme5_1, null, [{
      key: "mobileModalCloseButtonRightPadding",
      get: function get() {
        return this.mobileModalCloseButtonClickArea;
      }
    }, {
      key: "mobileModalCloseButtonTopPadding",
      get: function get() {
        return this.mobileModalCloseButtonClickArea;
      }
    }, {
      key: "mobileSidePageCloseButtonPadding",
      get: function get() {
        return this.mobileSidePageCloseButtonClickArea;
      }
    }, {
      key: "sidePageCloseButtonClickAreaTop",
      get: function get() {
        return this.modalCloseButtonClickAreaTop;
      }
    }, {
      key: "sidePageCloseButtonClickAreaBottom",
      get: function get() {
        return this.modalCloseButtonClickAreaBottom;
      }
    }, {
      key: "sidePageCloseButtonClickAreaLeft",
      get: function get() {
        return this.modalCloseButtonClickAreaLeft;
      }
    }, {
      key: "sidePageCloseButtonClickAreaRight",
      get: function get() {
        return this.modalCloseButtonClickAreaRight;
      }
    }]);
  }(BasicThemeClassForExtension), _DarkTheme5_.modalCloseButtonClickAreaTop = '30px', _DarkTheme5_.modalCloseButtonClickAreaBottom = '22px', _DarkTheme5_.modalCloseButtonClickAreaLeft = '24px', _DarkTheme5_.modalCloseButtonClickAreaRight = '28px', _DarkTheme5_.mobileModalCloseButtonClickArea = '22px', _DarkTheme5_.sidePageHeaderStickyOffset = '10px', _DarkTheme5_.mobileSidePageCloseButtonClickArea = '22px', _DarkTheme5_.sidePageCloseButtonWrapperFixedOffsetTop = '4px', _DarkTheme5_.sidePageCloseButtonWrapperOffsetTop = '2px', _DarkTheme5_),
  prototypeTheme: DarkTheme5_0,
  themeMarkers: [markThemeVersion('5.1')]
});